import React, { useState } from "react";
import API_BASE_URL from "../../apiConfig";

const ChangeHomeContent = () => {
  const [announcementText, setAnnouncementText] = useState("");
  const [banners, setBanners] = useState([null, null, null, null, null]);
  const apiUrl = `${API_BASE_URL}/HomeBannerContent/uploadHomeContent`;

  // Handle file selection
  const handleFileChange = (index, event) => {
    const files = [...banners];
    files[index] = event.target.files[0]; // Store file
    setBanners(files);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("AnnouncementText", announcementText);

    banners.forEach((file, index) => {
      if (file) {
        formData.append(`Banner${index + 1}`, file);
      }
    });

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        alert("Content uploaded successfully!");
        console.log("Uploaded Data:", data);
      } else {
        alert("Upload failed: " + data.Message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
 
        <form onSubmit={handleSubmit}>
          <div className="card card-default">
            <div className="card-body">
              <div className="tab-content mt-2">
                <div className="row">
                  <div className="form-group col-md-8">
                    <label>Advertising content left to right</label>
                    <input
                      type="text"
                      className="form-control"
                      name="announcementText"
                      value={announcementText}
                      onChange={(e) => setAnnouncementText(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <h5 className="mb-3 mt-4">Upload Banner</h5>
                <div className="row">
                  {[0, 1, 2, 3, 4].map((index) => (
                    <div className="col-md-4" key={index}>
                      <input
                        type="file"
                        className="form-control"
                        name={`Banner${index + 1}`}
                        onChange={(event) => handleFileChange(index, event)}
                      />
                      <p>BANNER {index + 1}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="form-footer pt-2 pb-2">
                <button type="submit" className="btn btn-primary btn-pill">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      
  );
};

export default ChangeHomeContent;




// import React, { useState } from "react";


// const ChanageHomeContent = () => {
  
//   return (
//     <>
//         <div className="row">
// 				  <div className="col-xl-12">
//             <form>
//               <div className="card card-default">
//                 <div className="card-body">	
//                   <div className="tab-content mt-2">
//                   <div className="row">
//                       <div className="form-group col-md-8">
//                         <label>Advertising content left to right</label>
//                       </div>
//                       <div className="form-group col-md-8">
//                         <input type="text" className="form-control" name="text" />
//                       </div>  
//                     </div>
//                     <h5 className="mb-3 mt-4">Upload Banner</h5>	
//                     <div className="row">
//                       <div className="col-md-4">
//                         <input type="file" className="form-control" name="Upload" />
//                         <p>BANNER 1 </p>
//                       </div>
//                       <div className="col-md-4">
//                         <input type="file" className="form-control" name="Photo" />
//                         <p>BANNER 2 </p>
//                       </div>
//                       <div className="col-md-4">
//                         <input type="file" className="form-control" name="Signature" />
//                         <p for="AONo">BANNER 3 </p>
//                       </div>
//                       <div className="col-md-4">
//                         <input type="file" className="form-control" name="Signature" />
//                         <p for="AONo">BANNER 4 </p>
//                       </div>
//                       <div className="col-md-4">
//                         <input type="file" className="form-control" name="Signature" />
//                         <p for="AONo">BANNER 5 </p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="form-footer pt-2 pb-2">
//                   <button type="submit" className="btn btn-primary btn-pill">Submit</button>
//                 </div>
//                 </div>
                
//               </div>					
//             </form>  
// 				</div>
//       </div>
//     </>

//   );
// };
// export default ChanageHomeContent;
